import { ShieldCheck, ShieldAlert } from 'lucide-react'
import { cn } from '@/lib/utils'

interface CVEBadgeProps {
  count: number
  size?: 'sm' | 'md' | 'lg'
}

export default function CVEBadge({ count, size = 'sm' }: CVEBadgeProps) {
  const isClean = count === 0

  const sizeClasses = {
    sm: 'text-xs px-2 py-0.5',
    md: 'text-sm px-2.5 py-1',
    lg: 'text-base px-3 py-1.5',
  }

  const iconSizes = {
    sm: 'h-3 w-3',
    md: 'h-4 w-4',
    lg: 'h-5 w-5',
  }

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full font-medium',
        sizeClasses[size],
        isClean
          ? 'bg-accent-900/50 text-accent-400 border border-accent-700'
          : 'bg-red-900/50 text-red-400 border border-red-700'
      )}
    >
      {isClean ? (
        <>
          <ShieldCheck className={iconSizes[size]} />
          0 CVEs
        </>
      ) : (
        <>
          <ShieldAlert className={iconSizes[size]} />
          {count} CVE{count !== 1 ? 's' : ''}
        </>
      )}
    </span>
  )
}
